import { createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const store = (window.devToolsExtension
? window.devToolsExtension()(createStore)
: createStore)(rootReducer, {}, applyMiddleware(thunk));

export default store


// WEBPACK FOOTER //
// ./src/store.js